import { render, staticRenderFns } from "./ListarFormacoesDialog.vue?vue&type=template&id=4d36b06e"
import script from "./ListarFormacoesDialog.vue?vue&type=script&lang=js"
export * from "./ListarFormacoesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports